/* eslint-disable react/prop-types */
import React from 'react';
import { P } from '@contently/toolkit';
import { removeCentsAddCommas } from '../value/utils';

const RegularCell = ({ cell }) => {
  const traffic = removeCentsAddCommas(Number(cell.value));

  return <P>{traffic}</P>;
};

export default RegularCell;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/RegularCell.jsx